(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-content/page-footer/helpers/footer-handlebars-helper.js') >= 0) return;  svs.modules.push('/components/tb-content/page-footer/helpers/footer-handlebars-helper.js'); 
(function() {
  'use strict';

  if (typeof exports === 'object') {
    registerHelpers(require('hbs'));
  } else {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    hbs.registerHelper('partnerColClasses', function(idx, len) {
      var count = idx + 1,
        smClass = 'col-sm-',
        mdClass = 'col-md-',
        smMaxLogosPerRow = 3, 
        sm = len % smMaxLogosPerRow,
        mdMaxLogosPerRow = 6, 
        md = len % mdMaxLogosPerRow;

      if (count > len - sm) {
        smClass = 'col-sm-' + (12 / sm).toString();
      } else {
        smClass = 'col-sm-' + (12 / smMaxLogosPerRow).toString();
      }

      if (count > len - md) {
        mdClass = 'col-md-' + (12 / md).toString();
      } else {
        mdClass = 'col-md-' + (12 / mdMaxLogosPerRow).toString();
      }

      return 'col-xs-12 ' + smClass + ' ' + mdClass;
    });
  }
})();

 })(window);